import { isNotEmpty } from '@helpers'

export const isEmptyValue = (val: unknown): boolean => {
  if (Array.isArray(val)) return val.length === 0

  return !isNotEmpty(val)
}
